var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarrierIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "15px",
    viewBox: "0 0 23 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/carrier icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Guidelines",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-Spacings-and-Sizes",
    transform: "translate(-1470.000000, -2722.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-card-copy-2",
    transform: "translate(1311.000000, 2700.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-1",
    transform: "translate(0.000000, 0.980975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(79.000000, 21.019025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "carrier-icon",
    transform: "translate(80.000000, 0.980975)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#000000",
    points: "14.7703231 7.17948718e-05 -3.58974359e-05 1.37099487 -3.58974359e-05 12.5802085 14.7703231 13.9511316 22.9743231 12.6561915 22.9743231 1.29501197"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#FFFFFF",
    points: "0.872666667 11.7314256 0.872666667 2.21980171 13.7683419 1.16561368 13.7683419 12.7856137"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#FFFFFF",
    points: "21.2736701 12.1766496 17.6839265 12.6863932 17.6839265 7.06246154 21.2736701 6.94280342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#000000",
    points: "4.50564274 5.52906667 1.5740188 5.52906667 1.5740188 3.25556239 4.50564274 3.01624615"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#000000",
    points: "8.21504444 5.52906667 5.04410427 5.52906667 5.04410427 3.01624615 8.21504444 2.77692991"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#000000",
    points: "9.11248034 5.52906667 12.5227368 5.52906667 12.5227368 2.53761368 9.11248034 2.77692991"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#000000",
    points: "8.69367692 12.4692496 4.50564274 12.0977111 4.50564274 7.44995043 8.69367692 7.56326667"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrierIcon);
export default __webpack_public_path__ + "static/media/carrier_icon.d15652fe984b85145ca6ba5c92e38ab6.svg";
export { ForwardRef as ReactComponent };